import { createActionGroup } from '@ngrx/store';

export const OrganisationAzureLoginActions = createActionGroup({
  source: 'Organisation Azure Login',
  events: {}
});
